export default __webpack_public_path__ + "static/media/google-icon.8203ff10.svg";